import { render, staticRenderFns } from "./ClearAllScores.vue?vue&type=template&id=c84e2d2a&"
import script from "./ClearAllScores.vue?vue&type=script&lang=js&"
export * from "./ClearAllScores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports